import { SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';

export default function Plus(props: Partial<SVGProps<any>>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"  {...props} className={twMerge(props.className)}>
      <g clipPath="url(#clip0_745_11891)">
        <path d="M8 1V15M1 8H15" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_745_11891">
          <rect width="16" height="16" fill="none"/>
        </clipPath>
      </defs>
  </svg>
  )
}